import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import googleIcon from '../../../assets/icons/google.svg';
import facebookIcon from '../../../assets/icons/facebook-signup.svg';
import xIcon from '../../../assets/icons/x.svg';
import linkedinIcon from '../../../assets/icons/linkedin.svg';
import './LoginForm.css';

const EyeIcon = ({ show }) =>
  show ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );

export const LoginForm = ({ onSubmit, loading, error }) => {
  const [formData, setFormData] = useState({ mobile_no: '', password: '', remember: false });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(formData);
  };

  return (
    <div className="login-form-wrapper">
      <h2 className="login-title">Welcome Back</h2>
      <p className="login-subtitle">
        To join the BIZAARIO CARE UNIVERSE family, please
        <Link to="/signup" className="login-signup-link">Sign up</Link>
      </p>

      {error && (
        <div className="alert alert-danger py-2" role="alert">
          {error}
        </div>
      )}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="loginMobile">
          <Form.Label className="login-label">Mobile Number</Form.Label>
          <Form.Control
            type="text"
            name="mobile_no"
            placeholder="Enter your mobile number"
            value={formData.mobile_no}
            onChange={handleChange}
            className="login-input"
            required
          />
        </Form.Group>

        <Form.Group className="mb-2" controlId="loginPassword">
          <Form.Label className="login-label">Password</Form.Label>
          <div className="login-input-eye">
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="login-input"
              required
            />
            <button
              type="button"
              className="login-eye-btn"
              onClick={() => setShowPassword(!showPassword)}
              aria-label="Toggle password visibility"
            >
              <EyeIcon show={showPassword} />
            </button>
          </div>
        </Form.Group>

        <div className="login-remember-row">
          <Form.Check
            type="checkbox"
            name="remember"
            id="rememberMe"
            label="Remember me"
            checked={formData.remember}
            onChange={handleChange}
            className="login-remember"
          />
          <Link to="/forgot-password" className="login-forgot-link">Forgot Password?</Link>
        </div>

        <Button type="submit" className="login-submit-btn w-100 mt-3" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </Button>
      </Form>

      <div className="login-divider">
        <span>OR</span>
      </div>

      <div className="login-social-row">
        <button className="login-social-btn" aria-label="Login with Google">
          <img src={googleIcon} alt="Google" width="18" height="18" />
        </button>
        <button className="login-social-btn" aria-label="Login with Facebook">
          <img src={facebookIcon} alt="Facebook" width="18" height="18" />
        </button>
        <button className="login-social-btn" aria-label="Login with X">
          <img src={xIcon} alt="X" width="18" height="18" />
        </button>
        <button className="login-social-btn" aria-label="Login with LinkedIn">
          <img src={linkedinIcon} alt="LinkedIn" width="18" height="18" />
        </button>
      </div>
    </div>
  );
};
